import { SEOLayout } from './SEOLayout';

const Contact = () => (
  <SEOLayout
    title="Contact Vergo | Get in Touch with Our Team"
    description="Contact the Vergo team for editorial questions, tool submissions, partnership inquiries, corrections, or press requests." keywords="contact Vergo, support, editorial, partnerships, press"
  >
    <article className="prose prose-invert max-w-3xl mx-auto px-4 py-16">
      <h1>Contact Vergo</h1>
      <p className="lead">
        We read every message. Pick the channel that best matches your reason for writing — it
        helps us respond faster and route your note to the right person.
      </p>

      <h2>Editorial &amp; corrections</h2>
      <p>
        Spotted incorrect pricing, an outdated feature list, or a tool that has shut down? We take
        accuracy seriously and publish corrections within 48 hours of verification.
      </p>
      <p>Email: <a href="mailto:editorial@vergoai.app">editorial@vergoai.app</a></p>

      <h2>Submit a tool</h2>
      <p>
        Built or discovered an AI tool we should review? You can submit it directly through our{' '}
        <a href="/submit-bot">submission form</a>. Submissions are evaluated against our{' '}
        <a href="/how-we-review">review methodology</a>. We do not guarantee inclusion, and a
        submission never influences ranking.
      </p>

      <h2>Partnerships &amp; affiliates</h2>
      <p>
        For affiliate programs, integrations, or co-marketing opportunities, write to{' '}
        <a href="mailto:partnerships@vergoai.app">partnerships@vergoai.app</a>. Note that
        partnerships never affect our editorial coverage or rankings.
      </p>

      <h2>Press &amp; media</h2>
      <p>
        Journalists, podcasters, and analysts can reach our team at{' '}
        <a href="mailto:press@vergoai.app">press@vergoai.app</a>. We can provide commentary on AI
        tooling trends, market data from our catalog, and on-the-record quotes.
      </p>

      <h2>Privacy &amp; data requests</h2>
      <p>
        For GDPR, CCPA, or other data-subject requests, please email{' '}
        <a href="mailto:privacy@vergoai.app">privacy@vergoai.app</a>. We respond within 30 days as
        required by law. See our <a href="/privacy-policy">Privacy Policy</a> for details on the
        data we collect and how to delete your account.
      </p>

      <h2>Security</h2>
      <p>
        Found a vulnerability? Please disclose responsibly to{' '}
        <a href="mailto:security@vergoai.app">security@vergoai.app</a>. We acknowledge reports
        within 72 hours.
      </p>

      <h2>General questions</h2>
      <p>
        For anything else, write to <a href="mailto:hello@vergoai.app">hello@vergoai.app</a>.
      </p>

      <h2>Mailing address</h2>
      <p>
        Vergo<br />
        Operated by the Vergo Team<br />
        Replies are handled remotely by our distributed team.
      </p>
    </article>
  </SEOLayout>
);

export default Contact;
